import React, { useContext, useEffect, useState } from 'react'

import { bool, shape } from 'prop-types'
import { branch } from 'baobab-react/higher-order'
import API from 'utils/API'
import csrfToken from 'utils/csrfToken'
import AccessToken from 'utils/AccessToken'
import isDOMAvailable from 'utils/isDOMAvailable'
import BaseTemplate from 'components/templates/BaseTemplate'
import Container from 'components/atoms/Container'
import Button from 'components/atoms/Button'
import InfoBox from 'components/molecules/InfoBox'
import NewModal from 'components/molecules/NewModal'
import SchoolsSelectionForm from '../SchoolsSelectionForm'
import { PaperplaneFormProvider, PaperplaneFormContext } from '../PaperplaneFormContext'

const PaperplaneReattempt = ({ hasOTScore }) => {
  const REQ_OPTS = {
    headers: {
      'X-CSRF-Token': csrfToken(),
      Authorization: `Token ${AccessToken.get()}`,
    },
  }

  const { state, dispatch } = useContext(PaperplaneFormContext)
  const [confirmOpen, setConfirmOpen] = useState(false)
  const hasCompleteOT = hasOTScore.tps && (hasOTScore.saintek || hasOTScore.soshum)
  const [showThxNote, setShowThxNote] = useState(hasCompleteOT)

  const isButtonDisabled = () => !(state.programStudies[0] && state.programStudies[1])

  const submitScore = async () => {
    // setLoading(true)
    try {
      const results = await API.post(API.endPoints().paperplane.submit,
        {
          option_1_code: state.programStudies[0].id,
          option_2_code: state.programStudies[1].id,
          category: state.group,
        },
        REQ_OPTS
      )
      // setLoading(false)
      window.localStorage.clear()
      // eslint-disable-next-line no-console
      console.log('PREDICTION RESULTS', results)
      window.location = '/peluang-sbmptn/result'
    } catch (error) {
      // eslint-disable-next-line no-alert
      alert('Oops! Terjadi kesalahan, silakan coba beberapa saat lagi!')
    }
  }

  useEffect(() => {
    if (isDOMAvailable) {
      const initialState = window.localStorage.getItem('qc_paperplane_state')

      if (initialState) {
        dispatch({
          type: 'INIT_STATE_FROM_LOCALSTORAGE',
          payload: JSON.parse(initialState),
        })
      }
    }
  }, [])

  return (
    <BaseTemplate useNewHeader>
      <div className="paperplane-reattempt">
        <Container mobileFull>
          {showThxNote && (
            <InfoBox
              message="Terima kasih telah menyelesaikan Online Tryout! Silakan pilih universitas dan jurusan yang kamu inginkan"
              handleDismiss={() => setShowThxNote(false)}
            />
          )}
          <SchoolsSelectionForm classname="paperplane-reattempt" />
          <NewModal
            isOpen={confirmOpen}
            title="Apakah kamu sudah yakin dengan pilihanmu?"
            message="Pilihan jurusan & universitas hanya bisa diinput satu kali dan tidak dapat diubah kembali."
            cancel={{
              handle: () => setConfirmOpen(false),
              text: 'Batal',
            }}
            success={{
              handle: () => submitScore(),
              text: 'Submit',
            }}
          />
          <div className="paperplane-reattempt__control-button">
            <Button
              component="button"
              type="button"
              onClick={() => setConfirmOpen(true)}
              variant="default"
              disabled={isButtonDisabled()}
            >
              Submit
            </Button>
          </div>
        </Container>
      </div>

      <style jsx global>
        {`
          .paperplane-reattempt {
            &__control-button {
              display: flex;
              justify-content: flex-end;
              margin: 24px 0;

              @media screen and (max-width: 575px) {
                button {
                  width: 100%;
                  margin: 24px;
                }
              }
            }
            &__form {
              padding: 40px;
              margin-bottom: 24px;
            }
            .radio-item {
              display: inline-block;
              margin-right: 16px;

              input[type="radio"]{
                margin-right: 8px;
              }

              span {
                font-size: 16px;
              }
            }
            .fields-group {
              margin-bottom: 2rem;

              :global(h5) {
                margin-bottom: 1rem;
              }
              &:last-child {
                margin-bottom: 0;
              }
            }
            .form-group:last-child {
              margin-bottom: 0;
            }
            .Typography.text-variant-body {
              margin-bottom: 2rem;
            }
            .campus-paper {
              margin-bottom: 16px;
            }
            .button {
              margin-left: 16px;
              font-size: 16px;
              font-weight: bold;
              padding: 15px 32px;
              border: none;
            }
            .button-secondary {
              border: solid 1px #7d92a9;
              background-color: #ffffff;
              color: #1a344f;
            }
            .button[disabled] {
              background-color: #d3dce6;
              cursor: not-allowed;
            }
            .input-field[disabled] {
              background-color: #d3dce6;
              border: none;
            }
            @media screen and (max-width: 767px) {
              .cmps-col-md-3 {
                overflow: scroll;
              }
            }
          }
        `}
      </style>
    </BaseTemplate>
  )
}

const PaperplaneReattemptWithProvider = ({ has_ot_score: hasOTScore }) => (
  <PaperplaneFormProvider>
    <PaperplaneReattempt hasOTScore={hasOTScore} />
  </PaperplaneFormProvider>
)

PaperplaneReattemptWithProvider.propTypes = {
  has_ot_score: shape({
    tps: bool,
    saintek: bool,
    soshum: bool,
  }),
}

PaperplaneReattemptWithProvider.defaultProps = {
  has_ot_score: {
    tps: false,
    saintek: false,
    soshum: false,
  },
}

export { PaperplaneReattemptWithProvider }
export default branch({
  has_ot_score: ['serverProps', 'has_ot_score'],
}, PaperplaneReattemptWithProvider)
